/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 08/05/2025 07:39
 *
 */

import { Factory } from '@infodata-group/inf-commons';
import { PathDetailMatDto } from '../../dto/path/path-detail.dto';
import { AoPathMat } from '../../model/path/ao-path-mat';
import { PathPointMat } from '../../model/path/path-point/path-point-mat';
import { AoPathFactory } from './ao-path.factory';

export class AoPathMatFactory
  extends AoPathFactory
  implements Factory<AoPathMat>
{
  public override build(o: {
    trj: (PathDetailMatDto & { speed: string })[];
  }): AoPathMat {
    const paths: PathPointMat[] = o.trj.map((i) => {
      i.vitesse = i.speed;
      return new PathPointMat(i);
    });
    const pathMat = new AoPathMat(this._id, this._date, paths);
    pathMat.generateMarkers();
    pathMat.generatePolyline(this._settingsService);
    return pathMat;
  }

  public override getApi(): string {
    return `trajet/materiel/`;
  }
}
